//TODO:: LTO is on a newer cookie with a better cookie structure.  We are in the process of switching and phasing out this legacy cookie.
import newAccount from './newAccount.js';
import UserCookieBaseService from './userCookieBaseService.js';
import User from './user.js';
import {storage} from '@nuskin/ns-util';

/**
 *
 * LegacyUserCookieService
 *
 * @namespace LegacyUserCookieService
 * @ignore
 */
newAccount.LegacyUserCookieService = function(){
    "use strict";

    let STORAGE_KEY= storage.metadata.USER_COOKIE,
        userCookieService = new UserCookieBaseService(STORAGE_KEY);

    // ---------------------------------------------
    //
    //        Define methods to override.
    //
    // ---------------------------------------------
    userCookieService.getStoredUser = function(){
        let user = null;
        let cookieVal = JSON.parse(storage.getItem(STORAGE_KEY));
        if (cookieVal !== null && cookieVal !== undefined) {
            user = cookieVal;
        }
        return user;
    };
    userCookieService.writeUserToStorage = function(user){
        if (user == null || typeof (user) == 'undefined') {
            storage.removeItem(STORAGE_KEY);
        } else if (user.instance === User.instance) {
            storage.setItem(STORAGE_KEY, {user: user.toJSON()});
        } else{
            storage.setItem(STORAGE_KEY, {user: user});
        }
    };

    return userCookieService;
}();

export default newAccount.LegacyUserCookieService;
